import React, { useEffect, useMemo, useState } from "react";
import { ArrowLeft } from "lucide-react";
import i18n from "../../i18n";

const PorrCase = ({ imageName = "porr.jpg" }) => {
  const [langTick, setLangTick] = useState(0);

  useEffect(() => {
    const onLang = () => setLangTick((x) => x + 1);
    i18n.on("languageChanged", onLang);
    return () => i18n.off("languageChanged", onLang);
  }, []);

  const tr = useMemo(() => {
    void langTick;

    return {
      back: i18n.t("porrCase.back"),

      durationLabel: i18n.t("porrCase.labels.duration"),
      toolsLabel: i18n.t("porrCase.labels.tools"),

      org: {
        title: i18n.t("porrCase.org.title"),
        description: i18n.t("porrCase.org.description"),
        duration: i18n.t("porrCase.org.duration"),
      },

      intro: {
        title: i18n.t("porrCase.intro.title"),
        text: i18n.t("porrCase.intro.text"),
      },

      sap: {
        duration: i18n.t("porrCase.sap.duration"),
        title: i18n.t("porrCase.sap.title"),
        text: i18n.t("porrCase.sap.text"),
        bullets: [
          i18n.t("porrCase.sap.bullets.0"),
          i18n.t("porrCase.sap.bullets.1"),
          i18n.t("porrCase.sap.bullets.2"),
        ],
      },

      workflow: {
        duration: i18n.t("porrCase.workflow.duration"),
        title: i18n.t("porrCase.workflow.title"),
        text: i18n.t("porrCase.workflow.text"),
        bullets: [
          i18n.t("porrCase.workflow.bullets.0"),
          i18n.t("porrCase.workflow.bullets.1"),
          i18n.t("porrCase.workflow.bullets.2"),
        ],
      },
    };
  }, [langTick]);

  const tools = [
    "Java",
    "Spring",
    "Typescript",
    "Angular",
    "Apache",
    "Kubernetes",
    "Docker",
    "SAP",
  ];

  const toolMap = {
    Java: "java.png",
    Spring: "spring.png",
    Typescript: "typescript.png",
    Angular: "angular.png",
    Apache: "apache.png",
    Kubernetes: "kubernetes.png",
    Docker: "docker.png",
    SAP: "sap.png",
  };

  const handleBack = () => window.history.back();
  const imageUrl = `${process.env.PUBLIC_URL}/images/${imageName}`;

  return (
    <div>
      <div
        className="relative h-64 w-full bg-cover bg-center flex items-start justify-start"
        style={{ backgroundImage: `url(${imageUrl})` }}
      >
        <div className="max-w-screen-xl w-full">
          <button
            onClick={handleBack}
            className="flex items-center gap-2 text-gray-700 text-base font-medium py-2 px-4 bg-white/70 hover:bg-white rounded-full m-8"
            type="button"
          >
            <ArrowLeft className="w-5 h-5" />
            {tr.back}
          </button>
        </div>
      </div>

      <div className="flex flex-col md:flex-row gap-8 p-4 md:p-8">
        <div className="w-full md:w-[320px]">
          <div className="p-4 flex flex-col gap-4">
            <img
              src={`${process.env.PUBLIC_URL}/logos/porr.png`}
              alt="Porr Logo"
              className="h-14 object-contain self-start"
            />

            <div>
              <h2 className="text-lg font-semibold">{tr.org.title}</h2>
              <p className="text-sm text-gray-600">{tr.org.description}</p>
            </div>

            <div>
              <div className="text-sm text-gray-400">{tr.durationLabel}</div>
              <div className="text-sm font-medium">{tr.org.duration}</div>
            </div>

            <div className="mt-6">
              <div className="text-sm text-gray-400 mb-2">{tr.toolsLabel}</div>
              <div className="flex flex-col gap-2">
                {tools.map((tool) => {
                  const iconFile = `${process.env.PUBLIC_URL}/tools/${
                    toolMap[tool] || `${tool.toLowerCase()}.png`
                  }`;

                  return (
                    <div
                      key={tool}
                      className="flex items-center gap-3 px-5 py-2 bg-white rounded-full shadow text-sm font-medium w-[160px]"
                    >
                      <img
                        src={iconFile}
                        alt={`${tool} icon`}
                        className="w-7 h-7 object-contain"
                      />
                      {tool}
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </div>

        <div className="flex-1">
          <div className="px-2 sm:px-4 md:px-0">
            <div className="bg-white text-black font-sans px-0 md:px-6 py-8 space-y-10 rounded-xl">
              <div className="px-4 md:px-0 space-y-10">
                <section className="space-y-4">
                  <h2 className="text-xl font-semibold text-gray-800">
                    {tr.intro.title}
                  </h2>
                  <p>{tr.intro.text}</p>
                </section>
              </div>

              <section className="bg-gray-100 p-6 rounded-xl space-y-4">
                <p className="text-sm text-gray-500 font-medium">
                  {tr.durationLabel} {tr.sap.duration}
                </p>
                <h3 className="text-lg font-semibold">{tr.sap.title}</h3>
                <p>{tr.sap.text}</p>
                <ul className="list-disc list-inside text-gray-800">
                  {tr.sap.bullets.map((b, idx) => (
                    <li key={idx}>{b}</li>
                  ))}
                </ul>
              </section>

              <section className="bg-gray-100 p-6 rounded-xl space-y-4">
                <p className="text-sm text-gray-500 font-medium">
                  {tr.durationLabel} {tr.workflow.duration}
                </p>
                <h3 className="text-lg font-semibold">{tr.workflow.title}</h3>
                <p>{tr.workflow.text}</p>
                <ul className="list-disc list-inside text-gray-800">
                  {tr.workflow.bullets.map((b, idx) => (
                    <li key={idx}>{b}</li>
                  ))}
                </ul>
              </section>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PorrCase;






















